import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-547c4667"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "appg-progress-body"
};
const _hoisted_2 = {
  class: "barWrapper"
};
const _hoisted_3 = {
  class: "appg-progress percentage"
};
import Modal from '@/templates/argon-core/Modal.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
  __name: 'AppgProgressBar',
  setup(__props) {
    const {
      getters
    } = useStore();
    const progress = computed(() => getters['layout/getProgress']);
    const isShow = computed(() => getters['layout/getIsProgressBar']);
    const bar = computed(() => `background: linear-gradient(90deg,  #16469e ${progress.value}%,  #eeeeee ${progress.value}%);`);
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Modal, {
        show: _unref(isShow),
        size: 'sm',
        "show-close": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: "appg-progress bar",
          style: _normalizeStyle(_unref(bar))
        }, null, 4), _createElementVNode("h6", _hoisted_3, _toDisplayString(`${_unref(progress)}%`), 1)])])]),
        _: 1
      }, 8, ["show"]);
    };
  }
};